<template>
    <b-navbar toggleable="lg" id="main-menu">
        <div :class="containerClass">
            <b-navbar-brand :to="$getUrl(startPageLink)">
                <b-img :src="getLogo" :alt="getAltName"></b-img>
            </b-navbar-brand>
            <div class="nav-button-group">
                <b-navbar-toggle v-if="!isCheckout" target="nav-collapse">
                    <template>
                        <font-awesome-icon icon="fa-bars" />
                    </template>
                </b-navbar-toggle>
                <b-navbar-toggle class="pa-2" v-if="!isCheckout && !this.$root.whitelabel.isLeads()" target="profile-collapse">
                    <template>
                        <font-awesome-icon icon="fa-user" />
                    </template>
                </b-navbar-toggle>
            </div>
            <b-collapse v-if="!isCheckout" id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                    <b-nav-item class="pr-2" :to="$getUrl('landing-page')" v-if="landingPagePublished">{{ $t('nav.landing_page') }}</b-nav-item>
                    <b-nav-item class="pr-2" :to="$getUrl('catalog')">{{ $t('nav.catalog') }}</b-nav-item>
                    <b-nav-item class="pr-2" :to="$getUrl('about-subscription')">{{ $t('nav.about_subscription') }}</b-nav-item>
                    <b-nav-item class="pr-2" :to="$getUrl('cancel-subscription')" v-if="showCancellationEntry && !this.$root.whitelabel.isLeads()">
                        {{ $t('cdb.subscription.cancelSubscription.title') }}
                    </b-nav-item>
                    <b-nav-item-dropdown class="d-none d-lg-block" v-if="userLoggedIn" :text="$t('nav.account')" right>
                        <b-dropdown-item :to="$getUrl('cdb-dashboard')">
                            {{ $t('nav.subscription') }}
                        </b-dropdown-item>
                        <b-dropdown-item :to="$getUrl('cdb-dashboard-profile')">
                            {{ $t('nav.profile') }}
                        </b-dropdown-item>
                        <b-dropdown-item v-if="isFleetmanager" :to="$getUrl('fleetmanager-dashboard')">
                            {{ $t('nav.fleetmanager-dashboard') }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="logout">
                            {{ $t('nav.logout') }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                    <b-button v-else-if="!this.$root.whitelabel.isLeads()"
                            class="d-none d-lg-block mr-3 auth-button"
                            variant="outline-primary"
                            :to="$getUrl('login')"
                    >
                        {{ $t('nav.login') }}
                    </b-button>
                    <b-nav-item-dropdown class="d-none d-lg-block"
                        v-if="userLoggedIn && isFleetmanager"
                        :text="selectedCompany ? selectedCompany.name : $t('nav.company')"
                        right
                    >
                        <b-dropdown-item
                            v-for="(selectedCompany, index) in this.companies"
                            :key="index"
                            @click="setSelectedCompany(selectedCompany)"
                        >
                            {{ selectedCompany.name }}
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </b-navbar-nav>
            </b-collapse>
            <b-collapse v-if="!isCheckout" id="profile-collapse" is-nav>
                 <b-navbar-nav v-if="userLoggedIn" class="ml-auto">
                     <b-nav-item :to="$getUrl('cdb-dashboard')">{{ $t('nav.subscription') }}</b-nav-item>
                     <b-nav-item :to="$getUrl('cdb-dashboard-profile')">{{ $t('nav.profile') }}</b-nav-item>
                     <b-nav-item v-if="isFleetmanager && !this.$root.whitelabel.isLeads()" :to="$getUrl('fleetmanager-dashboard')">{{ $t('nav.fleetmanager-dashboard') }}</b-nav-item>
                     <b-nav-item @click="logout">{{ $t('nav.logout') }}</b-nav-item>
                 </b-navbar-nav>
                 <b-navbar-nav v-else-if="!this.$root.whitelabel.isLeads()">
                     <b-nav-item class="auth-button" :to="$getUrl('login')">{{ $t('nav.login') }}</b-nav-item>
                 </b-navbar-nav>
             </b-collapse>
            <b-navbar-nav v-if="isCheckout && isFleetmanager">
                <b-nav-item class="pr-2">{{ CompanyName }}</b-nav-item>
            </b-navbar-nav>
        </div>
    </b-navbar>
</template>
<script>

import Vue from "vue";
import {
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    BNavItemDropdown,
    BDropdownItem,
    BFormSelect,
    BNavForm,
    BButton,
    BImg
} from "bootstrap-vue"

export default Vue.extend({
    name: 'NavBar',
    components: {
        BNavbar,
        BNavbarBrand,
        BNavbarToggle,
        BCollapse,
        BNavbarNav,
        BNavItem,
        BNavItemDropdown,
        BNavForm,
        BDropdownItem,
        BFormSelect,
        BButton,
        BImg
    },
    props: {
      userLoggedIn: {
          required: true,
          type: Boolean,
      },
      variant: {
          type: String,
          required: false,
      }
    },
    data() {
        return {
            urlLanguage: '',
            companies: [],
            selectedCompany: JSON.parse(localStorage.getItem('selectedCompany')),
            isLoaded: false
        }
    },
    mounted() {
        this.handleLanguage()
        this.setDateFormat()
        this.getFleetmanagerCompanies()
    },
    beforeUpdate() {
        if (this.isLoaded === false) {
            this.getFleetmanagerCompanies()
        }
    },
    computed: {
        isFleetmanager() {
            if(this.$root.user?.state?.data?.core_user?.fleetmanager?.status === 'inactive') {
                return false
            }
            return !!this.$root.user?.state?.data?.core_user?.is_fleetmanager
        },
        containerClass(){
            return this.$root.whitelabel.setting('navigation_bar_content_width') ? 'container' : 'container-fluid'
        },
        showCancellationEntry(){
            return this.$root.whitelabel.setting('show_cancellation_menu_entry')
        },
        startPageLink() {
            return this.$root.whitelabel.setting('landing_page_published') ? 'landing-page' : 'catalog'
        },
        landingPagePublished() {
            return this.$root.whitelabel.setting('landing_page_published')
        },
        isCheckout() {
            return this.variant === 'checkout'
        },
        getLogo() {
            return this.$root.whitelabel.state.settings.logo ? this.$root.whitelabel.state.settings.logo : 'https://faaren.com/'
        },
        getAltName() {
            return this.$root.whitelabel.state.title ? this.$root.whitelabel.state.title : 'Faaren Whitelabel'
        },
        CompanyName() {
            return this.selectedCompany.name ?? ''
        }
        // temporary deactivated
        // locales() {
        //     let locales = []
        //     let { languages } = this.$root.whitelabel.state.settings
        //     languages.forEach(language => {
        //         const label = language.split('_')[0].toUpperCase()

        //         // frontend workaround because i18n somehow can't handle underscores coming from partner dashboard
        //         const vueI18nValue = language.replace('_', '-')
        //         locales.push({
        //             value: vueI18nValue,
        //             text: this.$t(`languages.${label}`)
        //         })
        //     })
        //     return locales
        // },
    },
    methods: {
        handleLanguage() {
            if(this.$route.name == 'landing-page' || this.$route.name == 'content-page') {
                const cookieLocale = this.$getCookie("locale")
                if(typeof cookieLocale !== 'undefined' && cookieLocale !== null && cookieLocale.trim() !== "") {
                    this.$root.$i18n.locale = cookieLocale
                } else {
                    // No cookie found => check whitelabel settings for correct language
                    const languages = this.$root.whitelabel.getSettings().languages

                    if (Array.isArray(languages)) {
                        if(languages.length < 1) {
                            console.error("Whitelabel has no languages set.")
                        } else {
                            this.$root.$i18n.locale = languages[0]
                        }
                    } else {
                        this.$root.$i18n.locale = languages
                    }
                }
            }

            this.saveToCookie()
        },
        logout() {
            this.$axios.post('/api/logout').then(response => {
                this.$goTo('catalog')
                location.reload();
            }).catch(error => {
                location.reload();
            });
        },
        saveToCookie() {
            const locale = this.$root.$i18n.locale

            this.$setLocaleCookie(locale)
            this.setDateFormat()
            if(this.userLoggedIn){
                this.$axios.get('/sanctum/csrf-cookie').then(() => {
                    this.$axios.put(`api/v1/profile/update_language`, {
                        locale: locale
                    })
                });
            }
        },
        setDateFormat() {
            this.$root.user.state.date_format = this.$root.$i18n.locale.includes('US') ? 'us' : 'eu'
        },
        getFleetmanagerCompanies() {
            if (this.$root.user?.state?.data?.core_user?.is_fleetmanager) {
                this.$axios.get('/api/v1/fleetmanager/fleetmanager-companies', {
                    params: { userId: this.$root.user.state.data.core_user.id }
                })
                .then(response => {
                    this.companies = response.data.payload
                    this.isLoaded = true
                })
                .catch(error => {
                    console.error(error);
                });
            }
        },
        setSelectedCompany(selectedCompany) {
            localStorage.setItem('selectedCompany', JSON.stringify(selectedCompany))
            this.setSessionParameter(selectedCompany)
        },
        setSessionParameter(selectedCompany) {
            this.$axios.post('api/set-session', {
                selectedCompany: selectedCompany
            }).then(() => {
                window.location.reload()
            }).catch(() => {
                console.error('Session parameter could not be set');
                localStorage.removeItem('selectedCompany')
                alert(this.$t('nav.company_change.error'))
            });
        }
    },
})
</script>
